import { Box } from '@mui/material'
import { useDemoMode } from '../../contexts/demo-mode-context'

/**
 * When admin demo mode is on, shows a solid mask instead of sensor identity text.
 * Does not render sensitive strings in the DOM in that mode.
 */
export function RedactedSensorField({
	children,
	inline = true,
	minWidth = 100,
	minHeight,
	sx = {},
	overlaySx = {},
}) {
	const { redactionActive } = useDemoMode()

	if (!redactionActive) {
		return children
	}

	return (
		<Box
			component="span"
			sx={{
				position: 'relative',
				display: inline ? 'inline-block' : 'block',
				minWidth,
				minHeight: minHeight ?? '1.25em',
				verticalAlign: 'middle',
				...sx,
			}}
			aria-label="Hidden in demo mode"
		>
			<Box
				aria-hidden
				sx={{
					position: 'absolute',
					inset: 0,
					borderRadius: 0.5,
					pointerEvents: 'none',
					bgcolor: theme =>
						theme.palette.mode === 'dark' ? 'grey.700' : 'grey.400',
					...overlaySx,
				}}
			/>
		</Box>
	)
}
